@if (!isOnline) {
    <div class="network-banner shadow-sm">
        <span class="status-text fw-semibold p-0"> Not Connected </span>
        @if (showRetryButton) {
            <button class="retry-button p-0" (click)="retryConnection()">
                {{ isRetrying ? "Retrying..." : "Retry Now" }}
            </button>
        }
        @if (!showRetryButton) {
            <span class="status-text">{{ "Connecting in " + countdown + "s" }}</span>
        }
    </div>
}
